<template>
  <div>

    <el-dialog title="学员报名" :visible.sync="showAdd" width="600px" :close-on-click-modal="false" center>
      <el-form ref="addFrom" :model="addFrom" :rules="addRules" label-width="100px">
        <el-form-item label="课程" prop="courseIdList">
          <el-select v-model="addFrom.courseIdList" clearable multiple placeholder="课程选择" filterable>
            <el-option v-for="(item, index) in allCourseList" :key="index" :label="item.courseName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="讲师" prop="lecturerUserId">
          <el-select v-model="addFrom.lecturerUserId" clearable placeholder="讲师选择" filterable>
            <el-option v-for="(item, index) in lecturerList" :key="index" :label="item.lecturerName"
              :value="item.userId + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上课时间" prop="startTime">
          <el-date-picker v-model="addFrom.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            :picker-options="{}"></el-date-picker>
        </el-form-item>
        <el-form-item label="上课地点">
          <el-input v-model="addFrom.address" placeholder="" style="width:400px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="培训内容">
          <el-input v-model="addFrom.trainingContent" placeholder="" style="width:400px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="城市" prop="cityId">
          <el-select v-model="addFrom.cityId" @change="chooseCity" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="驿站">
                    <el-select v-model="addFrom.postStationId" @change="choosePostStation" clearable placeholder="请选择驿站" filterable>
                        <template v-for="(item,index) in postStationList">
                            <el-option :key="index" v-if="item.cityId==addFrom.cityId" :label="item.postStationName" :value="item.id+''"> </el-option>
                        </template>
</el-select>
</el-form-item> -->

        <el-form-item label="服务站">
          <el-select v-model="addFrom.stationId" @change="getAllWorker" clearable placeholder="请选择服务站" filterable>
            <template v-for="(item, index) in allStationList">
              <el-option :key="index" v-if="item.cityId == addFrom.cityId" :label="item.stationName" :value="item.id + ''">
              </el-option>
              <!-- v-if="item.postStationId==addFrom.postStationId"-->
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="服务者" prop="workerNoList">
          <el-select v-model="addFrom.workerNoList" multiple clearable placeholder="请选择服务者" filterable>
            <template v-for="(item, index) in allWorkerData">
              <el-option :key="index" :label="item.workerName" :value="item.workerNo"> </el-option>
            </template>
          </el-select>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">关闭</el-button>
        <el-button type="primary" @click="saveCourse('addFrom')">提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import wmsApi from "@/script/api/wmsApi";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
  data() {
    return {
      showAdd: false,

      courseArrangementList: [],
      cityList: [],
      postStationList: [],
      allStationList: [],

      allWorkerData: [], //服务者

      lecturerList: [], //讲师
      allCourseList: [], //课程

      addFrom: {
        courseIdList: [],
        lecturerUserId: '',
        startTime: '',
        address: '',
        trainingContent: '',

        workerNoList: [],

        cityId: null,
        postStationId: null,
        stationId: null,
      },

      addRules: {
        startTime: [
          {
            required: true,
            message: "请选择上课时间",
            trigger: "change",//blur
          },
        ],
        courseIdList: [
          {
            required: true,
            message: "请选择课程",
            trigger: "change",
          },
        ],
        cityId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        lecturerUserId: [
          {
            required: true,
            message: "请选择讲师",
            trigger: "change",
          },
        ],
        workerNoList: [
          {
            required: true,
            message: "请选择服务人员",
            trigger: "change",
          },
        ],

      },
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    close() {
      this.showAdd = false;
    },
    toaddStudyWorker(worker) {
      //从学员维度点击弹窗

    },
    // },
    addStudy(workerNo, cityId, workerName, allCourseList, cityList) {

      //重置表单校验状态
      this.$nextTick(() => {
        if (this.$refs.addFrom) {
          this.$refs.addFrom.clearValidate();
        }
      });

      this.loadData(); //加载数据

      this.getAllLecturer();

      this.showAdd = true;
      this.allCourseList = allCourseList;
      this.cityList = cityList;

      let item = null;
      if (workerNo && workerName) {
        item = {
          workerNo: workerNo,
          workerName: workerName
        }

        this.allWorkerData.push(item);

        // this.getAllWorker();

      }

      this.addFrom = {
        courseIdList: [],
        lecturerUserId: '',
        startTime: '',
        address: '',
        trainingContent: '',
        workerNoList: item ? [workerNo] : [],

        cityId: cityId,
        postStationId: null,
        stationId: null,
      };
    },
    loadData() {

      // //城市下拉框
      // wmsApi.$axiosgetallCity().then((res) => {
      //     if (res.data.errno == 0) {
      //         this.cityList = res.data.data;
      //     }
      // });

      // //驿站
      // crmApi.$axiosPostStationgetAllList().then((res) => {
      //     if (res.data.errno == 0) {
      //         this.postStationList = res.data.data;
      //     }
      // });

      //服务站
      wmsApi.$axiosGetAllStationList().then((res) => {
        if (res.data.errno == 0) {
          this.allStationList = res.data.data;
        }
      });
    },
    chooseCity() {
      this.addFrom.postStationId = null;
      this.addFrom.stationId = null;
      this.addFrom.workerNoList = [];
      this.getAllWorker();
    },
    choosePostStation() {
      this.addFrom.stationId = null;
      this.getAllWorker();
    },
    getAllWorker() {
      this.addFrom.workerNoList = [];
      if (this.addFrom.cityId == null || this.addFrom.cityId == "") {
        return; //至少选择城市
      }
      let req = {
        cityId: this.addFrom.cityId,
        postStationId: this.addFrom.postStationId,
        stationId: this.addFrom.stationId,
      };
      crmApi.$ajaxWorkerSupplierGetWorker(req).then((res) => {
        if (res.data.errno == 0) {
          this.allWorkerData = res.data.data;
        }
      });
    },

    saveCourse(formName) {
      // if(this.addFrom.courseIdList.length==0||this.addFrom.workerNoList.length==0){
      //        this.$message.error("请选择课程和服务者");
      //     return;
      // }
      this.addFrom.createUserId = globalData.userInfo.id;
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          crmApi
            .$ajaxemEmCourseEnrolmentAttendCourse(that.addFrom)
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                that.showAdd = false;
                that.$parent.querySearch();
              } else {
                this.$message.error(res.data.data);
              }
            }).catch(e => {
              console.log(e);
              this.$message.error("操作失败");
            });

        }
      });
    },
    getAllLecturer() {
      //获取讲师下拉框
      crmApi.$ajaxEmCourseGetAllLecturer().then((res) => {
        if (res.data.errno == 0) {
          this.lecturerList = res.data.data;
        }
      });
    },
    getCourseGetAllCourseList() {
      //获取讲师下拉框
      crmApi.$ajaxEmCourseGetAllCourseList().then((res) => {
        if (res.data.errno == 0) {
          this.allCourseList = res.data.data;
        }
      });
    },
  },
};
</script>
<style></style>
